import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { WizardStepIndex } from "../../shared/enums/WizardStep";
import { action } from "../../store/action";
import CustomContainer from "../shared/CustomContainer";
import Topbar from "../Topbar/Topbar";
import "./ThankYou.scss";

const ThankYou = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["endpage"]);

  dispatch(
    action.saveWizard({
      activeStepIndex: WizardStepIndex.Done,
      enableNext: false,
    })
  );

  return (
    <>
      <div className="content">
        <Topbar />
        <CustomContainer>
          <div className="tankyouContainer">
            <div className="thankyouContent">
              <h1>{t("welldone")}</h1>
              <p>{t("endpageinfo")}</p>
              <a href="https://www.rototilt.com/">
                <h3>{t("gotoweb")}</h3>
              </a>
            </div>
          </div>
        </CustomContainer>
      </div>
    </>
  );
};

export default ThankYou;
